export default {
	address: 'Adresse',
	addToCart: 'In den Warenkorb legen',
	belgium: 'Belgien',
	cart: 'Warenkorb',
	city: 'Stadt',
	country: 'Land',
	currentPage: 'aktuell',
	deliveryDate: 'Lieferdatum',
	deliveryFormat: '[Woche] w YYYY',
	email: 'E-Mail-Addresse',
	eta: 'ETA:',
	etaFormat: '[Woche] w',
	firstEta: 'Einer oder mehrere Artikel in Ihrem Warenkorb sind derzeit nicht auf Lager. Die erste verfügbare Lieferwoche ist {{week}}.',
	firstEtaFallback: 'Unbekannt',
	firstEtaFormat: '[Woche] w',
	friend: 'Wen kenne ich bei PTMD?',
	germany: 'Deutschland',
	itemNotFound: 'Artikel nicht gefunden',
	itemUnavailable: 'Dieser Artikel ist momentan nicht verfügbar',
	name: 'Name',
	netherlands: 'Niederlande',
	oops: 'Hoppla...',
	order: 'Bestellung aufgeben',
	orderDetails: 'Bestelldetails',
	phone: 'Telefonnummer',
	placeWishlist: 'Wunschliste platzieren',
	pleaseTilt: 'Gerät drehen',
	postalCode: 'Postleitzahl',
	stock: 'Vorrat: {{count}}',
	'stock_interval': '(999999){Vorrat: Bald erhältlich};',
	thanksForYourOrder: 'Vielen Dank für Ihre Click & Collect-Bestellung. Ihre Wunschliste wird nun an {{customer}} gesendet. {{customer}} wird sich so schnell wie möglich mit Ihnen in Verbindung setzen.',
	toggleFullScreen: 'Vollbild umschalten',
	total: 'Gesamtmenge:',
	useSafari: 'Bitte verwenden Sie Safari als Ihren Browser.',
	yourShop: 'Dein Laden: {{customer}}'
};
